import { FC } from "react";
import {
  PageEnum,
} from "../../models";
import {UnitManagement} from "../../components";
export const UnitPage: FC<{ formId: number }> = ({
}) => {
  //#region html
  return (  <UnitManagement/>)
  //#endregion
};
